import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OESurgeryTargetType = {
    orthoOp:        'orthoOp',
    ophthalmology:  'ophthalmology',
    approachOp:     'approachOp',
    anatomy:        'anatomy'
};

OESurgeryTargetType.all = [
    OESurgeryTargetType.anatomy,
    OESurgeryTargetType.approachOp,
    OESurgeryTargetType.ophthalmology,
    OESurgeryTargetType.orthoOp
];

export const OESurgeryStartSelectionContent = {

    // alpha
    [OESurgeryTargetType.orthoOp]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],

    // alpha
    [OESurgeryTargetType.ophthalmology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],

    // alpha
    [OESurgeryTargetType.approachOp]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                }
            ]
        }
    ],

    // alpha
    [OESurgeryTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanLarynx
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot,
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanTrunkVessel,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],

    // beta
    [OESurgeryTargetType.orthoOp + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],

    // beta
    [OESurgeryTargetType.ophthalmology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],

    // beta
    [OESurgeryTargetType.approachOp + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                }
            ]
        }
    ],

    // beta
    [OESurgeryTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanLarynx,
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand,
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanAnkleFoot,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanChestWall
                    ]
                }
            ]
        }
    ],

    // prod
    [OESurgeryTargetType.orthoOp + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],

    // prod
    [OESurgeryTargetType.ophthalmology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],

    [OESurgeryTargetType.approachOp + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                }
            ]
        }
    ],

    [OESurgeryTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanLarynx,
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand,
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanAnkleFoot,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanChestWall
                    ]
                }
            ]
        }
    ]
};

OESurgeryStartSelectionContent.modules = [
    {id: OESurgeryTargetType.anatomy, icon: OEIconCodes.surgery.anatomyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.anatomy]},
    {id: OESurgeryTargetType.approachOp, icon: OEIconCodes.surgery.approachOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.approachOp]},
    {id: OESurgeryTargetType.ophthalmology, icon: OEIconCodes.surgery.ophthalmologyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.ophthalmology]},
    {id: OESurgeryTargetType.orthoOp, icon: OEIconCodes.surgery.orthoOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.orthoOp]},
];

OESurgeryStartSelectionContent.modulesBeta = [
    {id: OESurgeryTargetType.anatomy, icon: OEIconCodes.surgery.anatomyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OESurgeryTargetType.approachOp, icon: OEIconCodes.surgery.approachOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.approachOp + OEAlphaBetaProdTypes.beta]},
    {id: OESurgeryTargetType.ophthalmology, icon: OEIconCodes.surgery.ophthalmologyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.ophthalmology + OEAlphaBetaProdTypes.beta]},
    {id: OESurgeryTargetType.orthoOp, icon: OEIconCodes.surgery.orthoOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.orthoOp + OEAlphaBetaProdTypes.beta]},
];

OESurgeryStartSelectionContent.modulesProduction = [
    {id: OESurgeryTargetType.anatomy, icon: OEIconCodes.surgery.anatomyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    //{id: OESurgeryTargetType.approachOp, icon: OEIconCodes.surgery.approachOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.approachOp + OEAlphaBetaProdTypes.prod]},
    {id: OESurgeryTargetType.ophthalmology, icon: OEIconCodes.surgery.ophthalmologyTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.ophthalmology + OEAlphaBetaProdTypes.prod]},
    {id: OESurgeryTargetType.orthoOp, icon: OEIconCodes.surgery.orthoOpTarget, categories: OESurgeryStartSelectionContent[OESurgeryTargetType.orthoOp + OEAlphaBetaProdTypes.prod]},
];
